import { InfoOutlined } from '@mui/icons-material'
import { Box, Button, Container, Fade, IconButton, Tooltip, Typography, useTheme } from '@mui/material'
import Grid from '@mui/material/Unstable_Grid2'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { toggleFormEvent } from '../../../../../redux/actions/events'
import { IRootState } from '../../../../../redux/types'
import CustomChip from '../../../../shared/components/CustomChip'
import CustomSnackBar from '../../../../shared/components/CustomSnackBar'
import Header from '../../../../shared/components/Header'
import NotFilter from '../../../../shared/components/NotFilter'
import ScreenLoading from '../../../../shared/components/ScreenLoading'
import AdminContentFilter from '../../../../shared/components/filters/AdminContentFilter'
import CountriesFilter from '../../../../shared/components/filters/CountryFilter'
import useScreenWidth from '../../../../shared/hooks/useScreenWidth'
import SubHeader from '../../../../shared/styles/Subheader'
import { tableScreenStyles } from '../../../../shared/styles/TableScreenStyles'
import EventsModal from '../components/EventsModal'
import EventTable from '../components/EventTable'
import useIntialState from '../hooks/useInitialState'
import useHandleFilters from '../hooks/useHandleFilters'

function Events() {
  const { t } = useTranslation(['global'])
  const isMobile = useScreenWidth(700)
  const theme = useTheme()
  const tableClass = tableScreenStyles(theme)
  const dispatch = useDispatch()

  const { events, showForm, error, msg, loading } = useSelector((state: IRootState) => state.event)
  const { adminContentFilter } = useIntialState()
  const { handleClickSetOptions } = useHandleFilters()

  return (
    <>
      <Header title={t('events')} />
      <SubHeader />
      <Container maxWidth="lg" sx={{ height: '100%' }}>
        <Box mt={isMobile ? 2 : 6} display="flex" flexDirection="column" gap={2}>
          <Box display="flex" justifyContent="center" alignItems="center" gap={1}>
            <Typography variant="h5">{t('all')}</Typography>
            <Tooltip
              TransitionComponent={Fade}
              TransitionProps={{ timeout: 600 }}
              arrow
              title={
                <Box>
                  <Typography variant="body2">{t('status')}:</Typography>
                  <Box display="flex" gap={1} alignItems="center">
                    <CustomChip size="small" color="primary" />
                    <Typography variant="caption">{t('active')}</Typography>
                  </Box>
                  <Box display="flex" gap={1} alignItems="center">
                    <CustomChip size="small" color="secondary" />
                    <Typography variant="caption">{t('inactive')}</Typography>
                  </Box>
                </Box>
              }
            >
              <IconButton>
                <InfoOutlined fontSize="small" htmlColor="#8F99A3" />
              </IconButton>
            </Tooltip>
          </Box>
          <Grid container justifyContent="space-between" spacing={1}>
            <Grid xs={12} sm={6} sx={tableClass.actionsResponsive}>
              <Button variant="outlined" color="secondary" onClick={() => dispatch(toggleFormEvent(true))}>
                {t('admin.events.create-event')}
              </Button>
            </Grid>
            <Grid xs={12} sm={6} sx={tableClass.actionsResponsiveRight}>
              <AdminContentFilter data={adminContentFilter} handleClick={opts => handleClickSetOptions(opts)} />
              <CountriesFilter />
            </Grid>
          </Grid>
          {events.length === 0 && !loading ? <NotFilter subsection={null} handleClearFilters={handleClickSetOptions} /> : <EventTable />}
        </Box>

        {showForm && <EventsModal />}

        <CustomSnackBar errors={[error]} msgs={[msg]} />
        <ScreenLoading loadings={[loading]} />
      </Container>
    </>
  )
}

export default Events
